/**
 * Configuration object for API endpoints
 *
 * @author Jaskiran Chhokar
 *
 * @constant apiConfig
 * @type {Object}
 */
const apiConfig = {
    /**
     * Configuration object the Connector Grid API
     *
     * These endpoints are used for interacting with the Connector Grid
     */
    connectorGrid: {
        /**
         * URL endpoint for sending data elements (without uID) and retrieving UID Cookies (uID and hpo_uID)
         * @type {string}
         */
        getUIDCookie: import.meta.env.VITE_GET_UID_COOKIE,
        /**
         * URL endpoint for sending data elements (with uID)
         * @type {string}
         */
        sendData: import.meta.env.VITE_SEND_DATA_TO_CONNECTOR_GRID,
        /**
         * x-api-key value for identifying the API consumer - for the uID endpoints
         * @type {string}
         */
        xApiKey: import.meta.env.VITE_UID_ENDPOINTS_X_API_KEY,
        /**
         * x-api-key value for identifying the API consumer - for the encryption API used to retrieve the public transport key
         * @type {string}
         */
        xApiKeyGetEncryptionKey: import.meta.env.VITE_ENCRYPTION_X_API_KEY,
        /**
         * authorization value for identifying the API consumer - for the encryption API used to retrieve the public transport key
         * @type {string}
         */
        authorizationToken: import.meta.env.VITE_AUTHORIZATION_TOKEN,
    },
    /**
     * Configuration object for the Geolocation API
     *
     * URL endpoint for retrieving various non-Pii user information (country, city, zip/postal code, etc.)
     * @type {string}
     */
    geolocation: {
        getUserLocation: import.meta.env.VITE_GEOLOCATION_URL,
    },
    encryption: {
        getPublicKey: import.meta.env.VITE_GET_ENCRYPTION_KEY,
    },
};

export default apiConfig;
